import React, { forwardRef, useEffect, useState } from "react";
import classNames from "classnames";
import { Input, InputProps } from "@campgladiator/cgui-core.atoms.input";
import { SearchBarProps } from "../../header";
import styles from "./header-search-bar.module.scss";

const getSearchBarIcon = (searchValueLength: number): InputProps["icon"] =>
  searchValueLength === 0
    ? { type: "solid", name: "icon-search" }
    : { type: "monochrome", name: "times-circle" };

const HeaderSearchBar = forwardRef<HTMLInputElement, SearchBarProps>(
  (
    {
      onSearchValueChange,
      inputSize = "small",
      changeOnKeyPress,
      placeholder,
      className,
      disabled = false,
      autofocus = false,
    }: SearchBarProps,
    ref
  ) => {
    const [searchValue, setSearchValue] = useState<string>("");

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (changeOnKeyPress && changeOnKeyPress == event.key)
        onSearchValueChange(searchValue);
    };

    useEffect(() => {
      onSearchValueChange(searchValue);
    }, [searchValue]);

    return (
      <div className={styles.searchWrapper}>
        <Input
          className={classNames(styles.search, className)}
          name="header-search-bar"
          id="header-search-bar"
          placeholder={placeholder}
          icon={getSearchBarIcon(searchValue.length)}
          inputSize={inputSize}
          onInputChange={setSearchValue}
          value={searchValue}
          onIconClick={() => setSearchValue("")}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          autoFocus={autofocus}
          ref={ref}
        />
      </div>
    );
  }
);

export default HeaderSearchBar;
